export enum MailingStatusEnum {
  pending = 'pending',
  common = 'common',
  blocked = 'blocked',
  approved = 'approved',
  new = 'new',
  /**
   * @description automatically set by system - [Mailing team explanation](https://systeme-team.slack.com/archives/C04VD9X0HK9/p1755508597669549)
   */
  new_pending = 'new_pending',
  /**
   * @description only used when sending to the BE, then they will transform it to `common` or `new`
   */
  new_common = 'common/new',
}

export const mailingStatusLocoKeys: Record<MailingStatusEnum, string> = {
  [MailingStatusEnum.pending]: 'dashboard.user.status.pending',
  [MailingStatusEnum.common]: 'dashboard.user.status.common',
  [MailingStatusEnum.blocked]: 'dashboard.user.status.blocked',
  [MailingStatusEnum.approved]: 'dashboard.user.status.approved',
  [MailingStatusEnum.new]: 'dashboard.user.status.new',
  [MailingStatusEnum.new_pending]: 'dashboard.user.status.new_pending',
  [MailingStatusEnum.new_common]: 'dashboard.user.status.new_common',
}

export const mailingStatusDescriptions: Record<MailingStatusEnum, string> = {
  [MailingStatusEnum.pending]: 'dashboard.user.status.pending_description',
  [MailingStatusEnum.common]: 'dashboard.user.status.common_description',
  [MailingStatusEnum.blocked]: 'dashboard.user.status.blocked_description',
  [MailingStatusEnum.approved]: 'dashboard.user.status.approved_description',
  [MailingStatusEnum.new]: 'dashboard.user.status.new_description',
  [MailingStatusEnum.new_pending]: 'dashboard.user.status.new_pending_description',
  [MailingStatusEnum.new_common]: 'dashboard.user.status.new_common_description',
}
